<template>
  <div class="linkRobot">
    <div class="guide-box" v-if="isShowGuide">
      <img src="@/assets/images/guide-1.png" />
      <p class="guide-text">{{ $t('请在safari浏览器中打开') }}</p>
    </div>
    <NavBar :narBarTitle="robotName" />
    <div class="frames-wrap" ref="frames">
      <div class="frames">
        <TRTCLIVE
          :config="rtcConfig"
          :muted="robotMute"
          v-if="!showPlayBtn"
          @onRemoteRoom="onRemoteRoom"
        />
        <img
          src="@/assets/images/playBtn.png"
          alt=""
          class="play"
          v-show="showPlayBtn"
          @click="playVideo"
        />
        <img
          src="@/assets/images/quit.png"
          alt=""
          class="quit"
          v-show="showQuit"
          @click="exitRoom"
        />
        <div class="robotVoice" v-show="showVoice">
          <img
            :src="
              !robotMute
                ? require('@/assets/images/onMicrophone.png')
                : require('@/assets/images/notMicrophone.png')
            "
            @click="onToggleRobotMute"
          />
        </div>
        <div class="openBox" v-show="showSuccess">
          <img src="@/assets/images/success.png" alt="" />{{
            $t('开门成功！请前往接待您的客户～')
          }}
        </div>
        <div class="openBox closeDoor" v-show="showFail">
          <img src="@/assets/images/error.png" alt="" />{{ $t('开门失败！') }}
        </div>
        <van-button
          round
          block
          v-show="showOpen"
          type="info"
          native-type="submit"
          class="open"
          @click.stop="openDoor"
          :style="{
            background: openTest ? '#009BFF' : '#F9F9F9',
            borderColor: openTest ? '#009BFF' : '#D9D9D9',
            color: openTest ? '#FFFFFF' : '#565656',
          }"
          :disabled="!openTest"
          >{{ $t('开门') }}</van-button
        >
      </div>
    </div>
    <div class="controlBox">
      <img src="@/assets/images/shang.png" alt="" @click="toLeft" />
      <div>
        <img src="@/assets/images/zuo.png" alt="" @click="downward" />
        <img src="@/assets/images/you.png" alt="" @click="upward" />
      </div>
      <img src="@/assets/images/xia.png" alt="" @click="toRight" />
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { isMobileType } from '@/utils/isMobileType.js'
import { initMqttConnection, getCommandTopic, getAPITopic } from '@/utils/utils'
import NavBar from '@/components/navBar'
import TRTCLIVE from '@/components/player/TrtcLive'
import {
  getUseSign,
  getSerialConfig,
  saveRobotConnect,
  breakRobotConnect,
  pingRobotConnect,
  joinRoom,
  getAccessControlNew,
  execDevice,
} from '@/services/api'
import Vue from 'vue'
import { Button } from 'vant'
Vue.use(Button)

const SDK_APPID = 1400501381
export default {
  name: 'LinkRobot',
  components: {
    NavBar,
    TRTCLIVE,
  },
  data() {
    return {
      showPlayBtn: true,
      robotMute: true,
      showQuit: false,
      robotName: '',
      roomId: '',
      serial: '',
      hostId: '',
      rtcConfig: {},
      deviceId: '',
      visitId: '',
      showOpen: false,
      registerTime: '',
      showSuccess: false,
      showFail: false,
      isShowGuide: false,
      token: '',
      mobile: '',
      id: '',
      developerId: null,
      resId: null,
      beat: null,
      showVoice: false,
    }
  },
  methods: {
    async playVideo() {
      this.showPlayBtn = false

      // 初始化 mqtt
      if (window.mqttClient && window.mqttClient.client.isConnected()) {
        this.enterLiveRoom()
      } else {
        initMqttConnection({
          userId: Date.now(),
          onConnected: this.onConnected,
        })
      }
      document.addEventListener('visibilitychange', this.switchPage)
      let date = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
      const res = await saveRobotConnect({
        beginTime: date,
        developerId: this.developerId,
        operatorId: this.id,
        operatorMobile: this.mobile,
        operatorTime: date,
        robotBindId: this.visitId,
        robotConnectReason: 'visit',
        robotId: this.serial,
        robotName: this.robotName,
      })
      this.resId = res
      this.beat = setInterval(this.ifLink, 30000)
      this.showQuit = true
      this.showOpen = true
      if (isMobileType.iOS()) {
        this.showVoice = true
      }
    },
    onConnected(reconnect) {
      if (reconnect) {
        console.log('MQTT', 'mqtt 重连成功')
      } else {
        console.log('MQTT', 'mqtt 连接成功')
        // mqtt 连接成功后，通知机器人进房
        // this.noticeRobotEnterRoom()
        this.enterLiveRoom()
      }
    },
    switchPage() {
      if (document.visibilityState === 'hidden') {
        this.exitRoom()
      }
    },
    async enterLiveRoom() {
      const roomData = await joinRoom(this.serial)
      this.roomId = roomData.id
      // 获取到房间 ID 后通知机器人进房
      this.noticeRobotEnterRoom()

      // const userData = await getAddUser(this.roomId)
      // this.userId = userData.id
      const userSignData = await getUseSign(SDK_APPID, this.userId)

      this.rtcConfig = {
        userID: this.userId,
        userSig: userSignData.userSig,
        sdkAppID: SDK_APPID,
        roomID: this.roomId,
      }

      // this.getLiveRoomInfo()
    },
    noticeRobotEnterRoom() {
      if (this.roomId) {
        // 连接成功后补发个进房 mqtt
        // window.mqttClient.publish(
        //   getCommandTopic(this.serial),
        //   JSON.stringify({
        //     command: 'enterRoom',
        //     payload: {
        //       roomID: parseInt(this.roomId),
        //       userId: this.userId
        //     },
        //   })
        // )
        window.mqttClient.publish(
          getAPITopic(this.serial),
          JSON.stringify({
            name: 'enterRoom',
            data: {
              roomID: parseInt(this.roomId),
              userId: this.userId,
            },
          })
        )
      }
    },
    exitRoom() {
      // 通知机器人退房并返回充电桩
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'exitRoom',
        })
      )
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'goTo',
          payload: 'home base',
        })
      )
      if (window.mqttClient) {
        window.mqttClient.disconnect()
      }
      breakRobotConnect({
        id: this.resId,
      })
      clearInterval(this.beat)
      this.showQuit = false
      this.showOpen = false
      this.showPlayBtn = true
      if (isMobileType.iOS()) {
        this.robotMute = true
        this.showVoice = false
      }
    },
    upward() {
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'tiltBy',
          payload: 10,
        })
      )
    },
    downward() {
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'tiltBy',
          payload: -10,
        })
      )
    },
    toLeft() {
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'skidJoy',
          payload: [0.3, 1],
        })
      )
    },
    toRight() {
      window.mqttClient.publish(
        getCommandTopic(this.serial),
        JSON.stringify({
          command: 'skidJoy',
          payload: [0.3, -1],
        })
      )
    },
    async getConfig(robotSerial) {
      await getSerialConfig({ robotSerial }).then((item) => {
        this.hostId = item.results[0].hostId
        this.deviceId = item.results[0].deviceId
      })
    },
    async openDoor() {
      try {
        let accessControlInformation = await getAccessControlNew(this.serial)
        const {
          communicationType,
          deviceId,
          deviceDetail,
          closeInterval,
          hostId,
        } = accessControlInformation
        const { DRIVER = null, DEVICE_GROUP_ID } = JSON.parse(deviceDetail)
        let openDoorType = communicationType == 2 ? 'host' : 'wifi'
        switch (openDoorType) {
          case 'wifi': //wifi开门模块
            break
          case 'host': {
            //主机开门
            if (!deviceId || !DRIVER) {
              return
            }

            let openData
            let closeData
            if (DRIVER == 'SIMPLE_CONTROL') {
              openData = {
                deviceId: deviceId + '',
                attribute: 'on',
              }
              closeData = {
                deviceId: deviceId + '',
                attribute: 'off',
              }
            } else {
              openData = {
                deviceId: deviceId + '',
                'On/Off': '1',
              }
              closeData = {
                deviceId: deviceId + '',
                'On/Off': '0',
              }
            }
            await execDevice({
              hostId: hostId,
              groupId: DEVICE_GROUP_ID,
              userName: this.mobile,
              operatingTerminal: 'H5',
              deviceConfig: { ...openData },
              companyId: this.developerId,
            })
            setTimeout(() => {
              execDevice({
                hostId: hostId,
                groupId: DEVICE_GROUP_ID,
                userName: this.mobile,
                operatingTerminal: 'H5',
                deviceConfig: { ...closeData },
                companyId: this.developerId,
              })
            }, closeInterval * 1000)
            break
          }
        }
        // await operateDevice(
        //   {
        //     hostId: this.hostId,
        //     deviceId: this.deviceId,
        //     mobile: this.mobile,
        //     item: 'On/Off',
        //     value: '1',
        //     source: 'H5',
        //     visitId: this.visitId,
        //   },
        //   this.token
        // )
        this.showSuccess = true
        setTimeout(() => {
          this.showSuccess = false
        }, 1000)
      } catch (error) {
        this.showFail = true
        setTimeout(() => {
          this.showFail = false
        }, 1000)
      }
    },
    onRemoteRoom(e) {
      if (e.isStart == false) this.exitRoom()
    },
    ifLink() {
      pingRobotConnect({ id: this.resId })
    },
    onToggleRobotMute() {
      this.robotMute = !this.robotMute
    },
  },
  computed: {
    openTest() {
      if (
        !this.registerTime ||
        dayjs(new Date()).valueOf() - dayjs(this.registerTime).valueOf() >
          30 * 60 * 1000
      ) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    this.robotName = this.$route.query.robotName
  },
  mounted() {
    if (isMobileType.iOS() && !isMobileType.isSafari()) {
      this.isShowGuide = true
    } else {
      this.isShowGuide = false
    }
    var width = document.documentElement.clientWidth
    var height = document.documentElement.clientHeight - 40
    if (width < height) {
      this.$refs.frames.style.width = height + 'px'
      this.$refs.frames.style.height = width + 'px'
      this.$refs.frames.style.top = (height - width) / 2 + 40 + 'px'
      this.$refs.frames.style.left = 0 - (height - width) / 2 + 'px'
      this.$refs.frames.style.transform = 'rotate(90deg)'
      this.$refs.frames.style.transformOrigin = `50% 50%`
    }
    this.serial = this.$route.query.serial
    this.visitId = this.$route.query.visitId
    this.registerTime = this.$route.query.registerTime
    this.token = this.$route.query.token
    this.mobile = this.$route.query.mobile
    this.id = this.$route.query.id
    this.developerId = this.$route.query.developerId
    this.getConfig(this.serial)
    this.userId = Date.now() + ''
  },
  destroyed() {
    this.showQuit && this.exitRoom()
    document.removeEventListener('visibilitychange', this.switchPage)
  },
}
</script>
<style lang="less" scoped>
.linkRobot {
  height: 100%;
  background: #f6f6f6;
  overflow: hidden;
  .robotVoice {
    img {
      width: 32px;
      height: 32px;
    }
  }
  .frames {
    height: 100%;
    width: 100%;
    position: relative;
    .openBox {
      font-size: 14px;
      display: flex;
      align-items: center;
      height: 40px;
      width: 300px;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      padding: 0 16px;
      color: rgba(0, 0, 0, 0.65);
      background: #ffffff;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08),
        0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      border-radius: 2px;
      img {
        margin-right: 8px;
        width: 17px;
        height: 17px;
      }
    }
    .closeDoor {
      width: 138px;
    }
    .play {
      width: 50px;
      height: 50px;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .quit {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 30px;
      right: 40px;
    }
    /deep/.open {
      position: absolute;
      width: 136px;
      height: 44px;
      background: #009bff;
      border-radius: 24px;
      left: 0;
      right: 0;
      bottom: 22px;
      margin: 0 auto;
      text-align: center;
      font-weight: 500;
      color: #ffffff;
      line-height: 44px;
    }
  }
  .controlBox {
    width: 100px;
    height: 100px;
    position: fixed;
    left: 40px;
    bottom: 65px;
    z-index: 999;
    display: flex;
    align-items: center;
    flex-direction: column;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    img {
      width: 31px;
      height: 30px;
    }
  }
}
@media screen and (orientation: portrait) {
  .frames-wrap {
    position: absolute;
    background-color: black;
  }
}
@media screen and (orientation: landscape) {
  .frames-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.guide-box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.84);
  z-index: 999999;
  padding: 0 1rem;
  img {
    width: 100%;
    height: 20rem;
  }
}
.guide-text {
  font-size: 1.5rem;
  line-height: 4rem;
  color: #ffffff;
}
</style>
